import React from 'react';
import { ChannelTile } from '../composition/shared/channelVisuals';
import { TEMPLATE_KINDS, CREATABLE_TEMPLATE_KINDS, TemplateKind } from './templateKinds';

const TemplateKindPicker: React.FC<{ onPick: (kind: TemplateKind) => void }> = ({ onPick }) => (
    <div className="max-w-4xl mx-auto py-10">
        <div className="text-center mb-8">
            <h2 className="text-2xl font-semibold text-gray-900 dark:text-gray-100">Que tipo de modelo você quer criar?</h2>
            <p className="text-sm text-gray-500 dark:text-gray-400 mt-1">
                O modelo nasce livre. Depois você pode usá-lo numa composição do mesmo canal.
            </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            {CREATABLE_TEMPLATE_KINDS.map((kind) => {
                const info = TEMPLATE_KINDS[kind];
                return (
                    <button
                        key={kind}
                        type="button"
                        onClick={() => onPick(kind)}
                        className="flex gap-4 text-left rounded-2xl border border-gray-200 dark:border-slate-700 bg-white dark:bg-slate-800 p-5 hover:shadow-md hover:border-teal-400 transition-all"
                    >
                        <ChannelTile channel={info.channel} size="lg" />
                        <span>
                            <span className="block font-semibold text-gray-900 dark:text-gray-100">{info.label}</span>
                            <span className="block text-[11px] uppercase tracking-wide text-gray-400">
                                {info.format} · {info.storage}
                            </span>
                            <span className="block text-sm text-gray-600 dark:text-gray-300 mt-2">{info.description}</span>
                        </span>
                    </button>
                );
            })}
        </div>
    </div>
);

export default TemplateKindPicker;
